const FormInputValidationMessage = ({ error }) => {
    return error && (
        <small style={{color: 'red'}}>{error.message}</small>
    );
};

export default FormInputValidationMessage;